<template>
	<PlayerControlButton label="Download video" :disabled="buttonDisabled" @click="onDownloadButtonClick">
		<BaseIcon :name="downloading ? 'mono/load' : 'mono/download'" class="w-full h-full" />
	</PlayerControlButton>
</template>

<script>
import analytics from 'shared/utils/analytics'
import PlayerControlButton from './PlayerControlButton.vue'
import {useSessionStore} from 'shared/stores/session'

export default {
	name: 'VideoPlayerDownloadControl',
	components: {PlayerControlButton},
	props: {
		videoUrl: {type: String, required: true},
		disabled: Boolean,
	},
	setup() {
		return {sessionStore: useSessionStore()}
	},
	data() {
		return {
			downloading: false,
		}
	},
	computed: {
		session() {
			return this.sessionStore.session
		},
		buttonDisabled() {
			return this.disabled || this.downloading
		},
	},
	methods: {
		onDownloadButtonClick() {
			if (this.buttonDisabled) return
			this.download()
		},
		async download(format = 'webm') {
			if (this.downloading) return
			this.downloading = true
			analytics.track('Download Video Button Clicked')
			if (this.$store.isExtension) {
				this.downloadFile(this.videoUrl, format)
				this.downloading = false
				return
			}

			try {
				this.$notify.success({title: 'Download requested'})
				const downloadUrl = await this.$api.get(`/storage/video/${this.session.id}.${format}?download=true`)
				this.downloadFile(downloadUrl, format)
				window.URL.revokeObjectURL(downloadUrl)
			} catch (error) {
				this.$notify.error({title: 'Download failed', message: error.message})
			} finally {
				this.downloading = false
			}
		},
		downloadFile(url, format) {
			const a = document.createElement('a')
			a.style.display = 'none'
			a.href = url
			const title =
				this.session.title || sessionStorage?.sessionTitle || `${this.$store.productName} ${this.session.id}`
			const filename = title
				.replace(/[^a-zA-Z0-9 -]/g, '') // remove any non-alphanumeric characters
				.replace(/\s+/g, '-') // replace spaces with hyphens
			a.download = `${filename}.${format}`
			document.body.appendChild(a)
			a.click()
		},
	},
}
</script>

<style scoped></style>
